import { useInitiateCustomersRewardsWithdrawalMutation } from 'hooks/mutations/Rewards/useInitiateCustomersRewardsWithdrawalMutation'
import { BaseErrorResponse } from 'types/beneficiaries'
import {
  CustomersEarningsWithdrawalRequest,
  CustomersRewardsWithdrawalResponse,
} from 'types/rewards'
import { useRewardsTracking } from '../useRewardsTracking'

export const useRewardsCustomerWithdraw = ({
  onSuccess,
  onError,
}: {
  onSuccess: (data: CustomersRewardsWithdrawalResponse) => void
  onError: (error: BaseErrorResponse) => void
}) => {
  const { trackSuccess, trackError } = useRewardsTracking()

  const {
    mutate: initiateCustomersRewardsWithdrawal,
    isPending: isRewardsCustomerWithdrawPending,
  } = useInitiateCustomersRewardsWithdrawalMutation()

  const onRewardsCustomerWithdraw = (data: CustomersEarningsWithdrawalRequest) => {
    const { destinationWalletId } = data

    return initiateCustomersRewardsWithdrawal(data, {
      onSuccess: (responseData: CustomersRewardsWithdrawalResponse) => {
        trackSuccess('customerWithdraw')
        onSuccess(responseData)
      },
      onError: (error: BaseErrorResponse) => {
        trackError('customerWithdraw', error, {
          walletId: destinationWalletId,
        })
        onError(error)
      },
    })
  }

  return {
    onRewardsCustomerWithdraw,
    isRewardsCustomerWithdrawPending,
  }
}
